// extracted by mini-css-extract-plugin
export default {"whiteDiv":"Contact_whiteDiv__pqBRs"};